// File: src/components/auth/role-redirect.tsx
// Purpose: Role-based dashboard redirect
// InstaDev - Role Redirect

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { RootState } from '@/store'

export function DashboardRedirect() {
  const navigate = useNavigate()
  const { userType } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    // Redirect based on user type
    const normalizedUserType = userType?.toLowerCase()
    console.log('DashboardRedirect: userType =', normalizedUserType)

    if (normalizedUserType === 'admin' || normalizedUserType === 'super_admin') {
      console.log('Redirecting to admin dashboard')
      navigate('/dashboard/admin/dashboard', { replace: true })
    } else if (normalizedUserType === 'staff' || normalizedUserType === 'employee' ||
               normalizedUserType === 'project_manager' || normalizedUserType === 'team_lead' ||
               normalizedUserType === 'developer') {
      console.log('Redirecting to staff dashboard')
      navigate('/staff', { replace: true })
    } else if (normalizedUserType === 'client') {
      console.log('Redirecting client to AI chat')
      navigate('/dashboard/ai-chat', { replace: true })
    } else {
      // Default to AI chat for other users
      console.log('Default redirect to AI chat')
      navigate('/dashboard/ai-chat', { replace: true })
    }
  }, [userType, navigate])

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
  )
}